import { Alert, Empty, Spin } from 'antd';
import type React from 'react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSubscriptions } from '../../../socket/useSubscription.ts';
import { useLabResultViewStore } from '../../../store/useLabResultViewStore.ts';
import { useUpdatedBefundStore } from '../../../store/useUpdatedBefundStore.ts';
import { BefundDetailsLayout } from './BefundDetailsLayout.tsx';
import { BefundDetailsHeader } from './header/BefundDetailsHeader.tsx';
import { useBefundDetailsContentStyles } from './useBefundDetailsContentStyles.ts';

export const BefundViewContent: React.FC<{
  myLabIdentifiers: string[] | undefined;
  deemphasizePathological?: boolean;
}> = ({ myLabIdentifiers, deemphasizePathological }) => {
  const styles = useBefundDetailsContentStyles();
  const selectedId = useLabResultViewStore(state => state.selectedId);
  const labResultState = useLabResultViewStore(state => state.labResultState);
  const loadLabResult = useLabResultViewStore(state => state.loadLabResult);

  //  const { data, error, isLoading, refetch } = useLabResult({ orderResultId: selectedId || '', markAsRead: true });

  const [updatesAvailable, setUpdatesAvailable] = useState(false);
  const setUpdatedBefund = useUpdatedBefundStore(state => state.setBefund);

  useEffect(() => {
    loadLabResult(false).finally();
  }, [loadLabResult]);

  useEffect(() => {
    if (selectedId && labResultState.value) {
      setUpdatedBefund({ id: selectedId, befund: labResultState.value });
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setUpdatesAvailable(false);
    }
  }, [selectedId, labResultState, setUpdatedBefund]);

  const callback = useCallback(() => setUpdatesAvailable(true), []);
  const subscriptionOptions = useMemo(
    () =>
      selectedId
        ? (myLabIdentifiers || []).map(li => ({
            type: 'befund-updated',
            id: selectedId,
            tenantId: li === '*:*' ? undefined : li,
          }))
        : [],
    [myLabIdentifiers, selectedId]
  );
  useSubscriptions(subscriptionOptions, callback);

  if (!selectedId) {
    return <Empty className={styles.empty} description="Bitte wählen Sie einen Befund aus" image={Empty.PRESENTED_IMAGE_DEFAULT} />;
  }
  if (labResultState.loading) {
    return <Spin></Spin>;
  }
  if (labResultState.error) {
    return <Alert type="warning" title="Fehler beim Laden der Daten" />;
  }

  if (!labResultState.value) {
    return <Empty className={styles.empty} description="Kein Befund gefunden" image={Empty.PRESENTED_IMAGE_DEFAULT} />;
  }

  return (
    <>
      <BefundDetailsHeader result={labResultState.value} refetch={updatesAvailable ? () => loadLabResult(true) : null} />
      <BefundDetailsLayout selectedResult={labResultState.value} deemphasizePathological={deemphasizePathological || false} />
    </>
  );
};
